// Translator notes: a translation taken from the verified memory (engine verified-memory.ts
// memoryResult; Axel's choice of 2026-10-09 "Verified memory first"). The Kääntäjä page's answer card
// names the source itself; letters list the note per line.
// Each id is an engine note (`notes.add(text, id, args)` or a memory result's noteItems); collected by
// translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

const FI_SOURCE: Record<string, string> = {
  'peterson-wiki': 'Petersonin esimerkkilause wikissä',
  'peterson-show': 'sarjan repliikki',
  'peterson-source': 'Petersonin lause muualta kuin wikistä',
  'peterson-phrase': 'sanakirjan fraasi',
  approved: 'hyväksymänne käännös',
  'ai-checked': 'Lausepinon lause',
  halloween: 'hyväksymänne Halloween-lause',
  session: 'tarkistussessiossa tehty käännös',
};
const EN_SOURCE: Record<string, string> = {
  'peterson-wiki': 'an example sentence by Peterson on the wiki',
  'peterson-show': 'a line from the show',
  'peterson-source': 'a sentence by Peterson outside the wiki',
  'peterson-phrase': 'a dictionary phrase',
  approved: 'a translation you approved',
  'ai-checked': 'a Lausepino sentence',
  halloween: 'a Halloween line you approved',
  session: 'a translation made in a review session',
};

export const notes = defineNotes({
  memoryAnswer: {
    args: ['source'],
    fi: (a: string[]) => `Valmis käännös: ${FI_SOURCE[a[0] ?? ''] ?? a[0] ?? ''}.`,
    en: (a) => `A ready translation: ${EN_SOURCE[a[0] ?? ''] ?? a[0] ?? ''}.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
